module.exports = __webpack_public_path__ + "static/media/Fire Blaze Golden_ Amazing Factory.3f0cc521.png";